import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';

import { ConfirmChangeDialogComponent } from './confirm-change-dialog.component';

@NgModule({
  declarations: [ConfirmChangeDialogComponent],
  imports: [CommonModule, FormsModule, MatButtonModule, MatCheckboxModule, MatDialogModule],
  exports: [ConfirmChangeDialogComponent],
})
export class ConfirmChangeDialogModule {}
